import { BELIMO_HASH_PREFIX } from 'src/BELIMO_HASH_PREFIX';

export enum PATHS {
    Home = `${BELIMO_HASH_PREFIX}/`,
    Sensors = `${BELIMO_HASH_PREFIX}/sensors`,
    SensorsFilter = `${BELIMO_HASH_PREFIX}/sensors-filter`,
    Accessories = `${BELIMO_HASH_PREFIX}/accessories`,
    Checkout = `${BELIMO_HASH_PREFIX}/checkout`,
    Share = `${BELIMO_HASH_PREFIX}/share`,
}
